<template>

  <div class="menubar-inner" style="width: 100%">
    <h6 class="menubar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
      Overzicht
    </h6>

    <b-nav class="flex-column">
      <b-nav-item to="/main/overview/tasks"><span class="mdi mdi-calendar"/> Takenlijst</b-nav-item>
    </b-nav>

    <h6 class="menubar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
      Administratie
    </h6>

    <b-nav class="flex-column">
      <b-nav-item to="/main/admin/contracts" ><span class="mdi mdi-file-document-outline"/> Contracten</b-nav-item>
      <b-nav-item to="/main/admin/printers" ><span class="mdi mdi-printer"/> Printers</b-nav-item>
      <b-nav-item to="/main/admin/invoices" ><span class="mdi mdi-receipt"/> Facturen</b-nav-item>
      <b-nav-item to="/main/admin/bigfox" ><span class="mdi mdi-printer-wireless"/> Bigfox</b-nav-item>
    </b-nav>

    <h6 class="menubar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
      Configuratie
    </h6>

    <b-nav class="flex-column">
      <b-nav-item to="/main/config/models"><span class="mdi mdi-database" /> Modellen</b-nav-item>
      <b-nav-item to="/main/config/profiles"><span class="mdi mdi-math-norm"/> Printer profielen</b-nav-item>
      <b-nav-item to="/main/config/cgroups"><span class="mdi mdi-counter" /> Tellergroepen</b-nav-item>
      <b-nav-item to="/main/config/integrations"><span class="mdi mdi-transit-connection-variant" /> Integraties</b-nav-item>
      <b-nav-item href="/api/v1/graphiql" target="_blank"><span class="mdi mdi-graphql" /> GraphQL API</b-nav-item>
    </b-nav>
  </div>

</template>

<script>

export default {}
</script>

<style>
</style>